import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Remark = (props) => {
  return (
    <FormGroup controlId="remark">
      <Col componentClass={ControlLabel} sm={5}>
        Remark
      </Col>
      <Col sm={7}>
        <textarea
          id="remark"
          rows="6"
          cols="50"
          maxLength="4000"
          value={props.remark}
          onChange={props.handleChangeRemark}
        />
      </Col>
    </FormGroup>
  )
}

Remark.propTypes = {
  remark: PropTypes.string,
  handleChangeRemark: PropTypes.func,

};

export default Remark;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/remark/Remark.js